export class UserSettings{ 

    public  LocationLatitude:number=0;
    public LocationLongitude:number=0;
    
    
    public  UserFCMToken :number=0;
    public  UserID :number=0;
    public Email :string='';
    // public Password :string='';
    public FirstName :string='';
    public LastName :string='';
    public City :string='';
    public State :string='';
    public PinCode :string='';
    public Country :string='';
    public  Address :string='';
    public  EmailVerified :number=0;
    public  MobilelVerified :number=0;
    public  RegistrationDate :string='';
    public EmailVerificationCode :string='';
    public MobileVerificationCode :string='';
    public ProfileImage :string='';
    public  Mobile :string='';
    public UnReadNotificationCount:number=0;
    public viewName="UserDetails";
  }